/**
 * Instruments a promise returning function,
 * returning time take to execute and success / failure
 */

export function instrumentAsync(task, measurementFn, taskName) {
  return function () {
    const start = performance.now();
    let isSuccess = false;
    return task(...arguments).then(results => {
      isSuccess = true;
      return results;
    }, error => {
      isSuccess = false;
      throw error;
    }).finally(() => {
      if (Array.isArray(measurementFn)) {
        measurementFn.forEach(fn => fn(taskName, isSuccess, performance.now() - start));
      } else {
        measurementFn(taskName, isSuccess, performance.now() - start);
      }
    });
  };
}